import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'alarmType/';

class AlarmTypeService {

    getList() {
        return axios.get(API_URL + 'getList', {
            headers: authHeader()
        });
    }

}

export default new AlarmTypeService();